export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/src/array.js
// module id = 1401
// module chunks = 0